import { createFileRoute } from '@tanstack/react-router';

// The list alone, with no newsletter open
export const Route = createFileRoute('/_authenticated/newsletters/')({});
